@if (isRoomMember() && canWrite()) {
  <div (click)="editor.chain().focus()" class="chat-input-container" role="textbox" tabindex="{0}">
    @if ((isUploading$ | async) || isSending) {
      <div class="loading-overlay">
        <mat-spinner diameter="30"></mat-spinner>
        <span>Nachricht wird verarbeitet...</span>
      </div>
    }

    <div role="toolbar" class="tt-toolbar">
      <span class="tt-formats">
        <button
          type="button"
          aria-pressed="false"
          aria-label="bold"
          [ngClass]="{ 'tt-active': editor.isActive('bold') }"
          (click)="editor.chain().focus().toggleBold().run()">
          <mat-icon svgIcon="bold"></mat-icon>
        </button>
        <button
          type="button"
          aria-pressed="false"
          aria-label="italic"
          [ngClass]="{ 'tt-active': editor.isActive('italic') }"
          (click)="editor.chain().focus().toggleItalic().run()">
          <mat-icon svgIcon="italic"></mat-icon>
        </button>
        <button
          type="button"
          aria-pressed="false"
          aria-label="underline"
          [ngClass]="{ 'tt-active': editor.isActive('underline') }"
          (click)="editor.chain().focus().toggleUnderline().run()">
          <mat-icon svgIcon="underline"></mat-icon>
        </button>
        <button
          type="button"
          aria-pressed="false"
          aria-label="strikethrough"
          [ngClass]="{ 'tt-active': editor.isActive('strike') }"
          (click)="editor.chain().focus().toggleStrike().run()">
          <mat-icon svgIcon="strikethrough"></mat-icon>
        </button>
      </span>

      <span class="tt-formats">
        <button
          type="button"
          aria-pressed="false"
          aria-label="delete"
          class="delete"
          [attr.data-testid]="testIds.buttonDelete"
          (click)="editor.chain().clearContent().run()">
          <mat-icon svgIcon="delete-icon"></mat-icon>
        </button>
      </span>
    </div>

    <tiptap-editor
      class="tiptap-editor"
      [attr.data-testid]="testIds.inputChat"
      [(ngModel)]="value"
      [editor]="editor"></tiptap-editor>

    <div class="btn-container">
      @if (isEditing) {
        <button mat-icon-button (click)="cancelEdit()" [attr.data-testid]="testIds.buttonCanceledit">
          <mat-icon svgIcon="circle-error"></mat-icon>
        </button>
        <app-file-upload (attachmentSelected)="onAttachmentSelected($event)"> </app-file-upload>

        <mat-icon svgIcon="split"></mat-icon>

        <button
          [attr.data-testid]="testIds.buttonEditmessage"
          mat-icon-button
          type="button"
          matTooltip="Nachricht senden"
          (click)="onSend()"
          (keydown.enter)="onSend()">
          <mat-icon svgIcon="send-message"></mat-icon>
        </button>
      } @else {
        <app-file-upload (attachmentSelected)="onAttachmentSelected($event)"> </app-file-upload>

        <mat-icon svgIcon="split"></mat-icon>
        <button
          [attr.data-testid]="testIds.buttonSendmessage"
          mat-icon-button
          type="button"
          matTooltip="Bearbeitung bestätigen"
          (click)="onSend()"
          (keydown.enter)="onSend()">
          <mat-icon svgIcon="send-message"></mat-icon>
        </button>
      }
    </div>
  </div>
}
